export default "/_next/static/c4222111e0fce3813e6f4c52a5858128.jpg";